import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Addp from './views/Addp.vue'
import Success from './views/Success.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/babusona',
      name: 'add',
      component: Addp
    },
    {
      path: '/success',
      name: 'success',
      component: Success
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
